export default __webpack_public_path__ + "static/media/agencyWhite.1cec7de9.png";